export { default } from "./AddProcessingUserAccess";



// WEBPACK FOOTER //
// ./src/components/list-items/ProcessingUser/ProcessingUserAccesses/AddProcessingUserAccess/index.js